import { render, staticRenderFns } from "./RecruiterQaThread.vue?vue&type=template&id=4d21c7f0&scoped=true"
import script from "./RecruiterQaThread.vue?vue&type=script&lang=js"
export * from "./RecruiterQaThread.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaThread.vue?vue&type=style&index=0&id=4d21c7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21c7f0",
  null
  
)

export default component.exports